import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import '../Register.css';
import hayatlogo from '../../assets/images/hayatlogo.jpg';
import hayatin from '../../assets/images/hayatin.jpg';
import google from '../../assets/images/google.jpg';
import facebook from '../../assets/images/facebook.jpg';
import ios from '../../assets/images/ios.jpg';
import passwordicon from '../../assets/images/passwordicon.jpg'
import passwordshowicon from '../../assets/images/passwordshowicon.jpg'
import axios from 'axios';


const Confirmpassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);
    const toggleConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);
    const navigate = useNavigate();
    const location = useLocation();

    // Form state
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({
        email: "",
        otp: "",
        password: "",
        confirmPassword: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [resetpassword, setResetPassword] = useState([]);

    // Load email and OTP from location state or localStorage on mount
    useEffect(() => {
        const storedEmail = localStorage.getItem('resetPasswordEmail');
        const storedOtp = localStorage.getItem('resetPasswordOtp');
        const emailFromState = location.state?.email;
        const otpFromState = location.state?.otp;
        
        if (emailFromState) {
            setEmail(emailFromState);
        } else if (storedEmail) {
            setEmail(storedEmail);
        }
        
        if (otpFromState) {
            setOtp(otpFromState);
        } else if (storedOtp) {
            setOtp(storedOtp);
        }
        
        console.log("Loaded email:", emailFromState || storedEmail);
        console.log("Loaded OTP:", otpFromState || storedOtp);
    }, [location.state]);

    // Email validation
    const validateEmail = (email) => {
        if (!email.trim()) {
            return "Email is required";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    // OTP validation
    const validateOtp = (otp) => {
        if (!otp.trim()) {
            return "OTP is required";
        }
        if (!/^\d+$/.test(otp.trim())) {
            return "OTP must contain only numbers";
        }
        if (otp.trim().length < 4) {
            return "OTP must be at least 4 digits";
        }
        return "";
    };

    // Password validation
    const validatePassword = (password) => {
        if (!password.trim()) {
            return "Password is required";
        }
        if (password.length < 6) {
            return "Password must be at least 6 characters";
        }
        return "";
    };

    // Confirm password validation
    const validateConfirmPassword = (confirmPassword, password) => {
        if (!confirmPassword.trim()) {
            return "Please confirm your password";
        }
        if (confirmPassword !== password) {
            return "Passwords do not match";
        }
        return "";
    };

    // Handle input changes
    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (errors.password) {
            setErrors(prev => ({ ...prev, password: "" }));
        }
        // Re-validate confirm password if it has a value
        if (confirmPassword) {
            const confirmError = validateConfirmPassword(confirmPassword, value);
            setErrors(prev => ({ ...prev, confirmPassword: confirmError }));
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        if (errors.confirmPassword) {
            setErrors(prev => ({ ...prev, confirmPassword: "" }));
        }
    };

    // Validate all fields
    const validateForm = () => {
        const newErrors = {
            email: validateEmail(email),
            otp: validateOtp(otp),
            password: validatePassword(password),
            confirmPassword: validateConfirmPassword(confirmPassword, password)
        };

        setErrors(newErrors);

        // Check if there are any errors
        return !Object.values(newErrors).some(error => error !== "");
    };

    const fetchresetpassword = async () => {
             
        // Check if email and OTP are available
        if (!email || !email.trim()) {
            alert("Email is missing. Please go back and verify your OTP again.");
            return;
        }
        
        if (!otp || !otp.trim()) {
            alert("OTP is missing. Please go back and verify your OTP again.");
            return;
        }
        
        // Validate form (only password fields will show errors in UI)
        const newErrors = {
            email: validateEmail(email),
            otp: validateOtp(otp),
            password: validatePassword(password),
            confirmPassword: validateConfirmPassword(confirmPassword, password)
        };
        
        setErrors(newErrors);
        
        const isValid = !Object.values(newErrors).some(error => error !== "");
        console.log("Form validation result:", isValid);
        console.log("Validation errors:", newErrors);
        
        if (!isValid) {
            // Show password-related errors
            if (newErrors.password) {
                alert(newErrors.password);
            } else if (newErrors.confirmPassword) {
                alert(newErrors.confirmPassword);
            } else if (newErrors.email) {
                alert(newErrors.email);
            } else if (newErrors.otp) {
                alert(newErrors.otp);
            } else {
                alert("Please check all fields and try again.");
            }
            return;
        }

        setIsLoading(true);
        
        // Ensure we have all required values
        const emailValue = email ? email.trim() : "";
        const otpValue = otp ? otp.trim() : "";
        const passwordValue = password ? password.trim() : "";
        
        const payload = {
            email: emailValue,
            otp: otpValue,
            password: passwordValue
        };
        
        try {
            const response = await axios.post(`http://localhost:8000/api/website/reset-password`, payload);
            setResetPassword(response.data);
            console.log("Reset password response:", response.data);
            
            // Navigate to login on success
            navigate('/login');
        } catch (error) {
            console.log("Error Fetching the Reset password", error);
            
            let errorMessage = "Password reset failed. Please try again.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
                
                // Check for specific field errors
                if (error.response.data.email) {
                    setErrors(prev => ({ ...prev, email: error.response.data.email }));
                }
                if (error.response.data.otp) {
                    setErrors(prev => ({ ...prev, otp: error.response.data.otp }));
                }
                if (error.response.data.password) {
                    setErrors(prev => ({ ...prev, password: error.response.data.password }));
                }
            }
            
            // Show general error if no specific field errors
            if (!error.response?.data?.email && !error.response?.data?.otp && !error.response?.data?.password) {
                alert(errorMessage);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchresetpassword();
    };

    return (
        <div className="register-container">
            <div className="register-left">
                <img src={hayatlogo} alt="Register" />
            </div>

            <div className='register-right'>
                <div className='rightside-header'>
                    <img src={hayatin} alt='hayatin' />
                    <div className='signin-account'>
                        <p>Remember Your Password</p>
                        <Link to="/login" className="signin-link">
                            Sign In
                        </Link>
                    </div>
                </div>

                <div className='center-banner'>
                    <div className='register-heading'>
                        <h4>Reset Your Password</h4>
                    </div>

                    <div className='form-container'>

                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <h6>Password <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={passwordicon} alt='passwordicon' className="input-icon" />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={handlePasswordChange}
                                        placeholder="Enter Your Password"
                                        required
                                    />
                                    <img
                                        src={passwordshowicon}
                                        alt='passwordshowicon'
                                        className="passwordshow-icon"
                                        onClick={togglePassword}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                                {errors.password && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.password}</span>}
                            </div>

                            <div className="input-group">
                                <h6>Confirm Password <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={passwordicon} alt='passwordicon' className="input-icon" />
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        value={confirmPassword}
                                        onChange={handleConfirmPasswordChange}
                                        placeholder="Confirm Your Password"
                                        required
                                    />
                                    <img
                                        src={passwordshowicon}
                                        alt='passwordshowicon'
                                        className="passwordshow-icon"
                                        onClick={toggleConfirmPassword}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                                {errors.confirmPassword && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.confirmPassword}</span>}
                            </div>
                            <div className='createaccount-button'>
                                <button 
                                    type="submit" 
                                    className="create-account-btn" 
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Resetting..." : "Submit"}
                                </button>
                            </div>

                        </form>
                        <div className="divider">
                            <hr /><p>Continue With</p><hr />
                        </div>
                        <div className='socialicon'>
                            <img src={google} alt='google' />
                            <img src={facebook} alt='facebook' />
                            <img src={ios} alt='ios' />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}


export default Confirmpassword